import axios from "axios";

export const backendUrl = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({
  baseURL: `${backendUrl}/api`,
  withCredentials: true,
});

export const assetUrl = (url) => {
  if (!url?.startsWith("/")) return url;
  const normalizedPath = url.startsWith("/uploads/") ? `/api${url}` : url;
  return `${backendUrl}${normalizedPath}`;
};

export const formatApiError = (error) => {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((item) => item.msg).join(" ");
  return "Something went wrong. Please try again.";
};